// extracted by mini-css-extract-plugin
module.exports = {"radioCustom":"styles_radioCustom__J6NME","input":"styles_input__I6UZr","select":"styles_select__0jzhI"};